import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { jsPDF } from "jspdf";
import { RobotoFont } from "../../utils/vfs";
import { AppMainComponent } from "src/app/app.main.component";
import { AppMainService } from "src/app/app-main.service";
import { CustomAttributeFieldType, TemplateType } from "../../constants/constants";
import { DatePipe } from "@angular/common";
import { UtilityService } from "../../utils/utility.service";
import { ICustomAtributes } from "../../models/customer-return.model";

@Component({
  selector: "app-return-print-email",
  templateUrl: "./return-print-email.component.html",
  styleUrl: "./return-print-email.component.scss",
})
export class ReturnPrintEmailComponent implements OnChanges {
  @Input() selectedReturn: any;
  @Input() companyInfo: any;
  @Input() displayReturnAdd;
  @Input() type;
  @Input() templates: any;
  @Input() allCustomAttributes: any;
  @Input() trackingOptions = [];
  @Input() decimalLength: number = 0;
  @Output() getCustomerReturnEmail = new EventEmitter<any>();
  allModules: any[] = [];
  customerReturnDetails;
  selectedProductListTable = [];
  productsSerialDetails = [];
  rmaTemplate: any;
  // barcode properties
  elementType = "img";
  format = "CODE128";
  lineColor = "#000000";
  width = 1;
  height = 20;
  displayValue = true;
  fontOptions = "";
  font = "monospace";
  textAlign = "center";
  textPosition = "bottom";
  textMargin = 5;
  fontSize = 14;
  background = "#ffffff";
  margin = 10;
  marginTop = 10;
  marginBottom = 10;
  marginLeft = 0;
  marginRight = 10;
  /** Custom Fields */
  customFieldData: any[] = [];
  allCustomFields: any[] = [];
  customAtributes: ICustomAtributes = {
    billing_address_item: [],
    shipping_address_item: [],
    misc_item: [],
    message_item: [],
    other1_item: [],
    other2_item: [],
    other3_item: [],
  };
  fieldTypes = CustomAttributeFieldType;
  utilService: UtilityService;

    // currency
    savedCurrencyUnit: any;
    savedCurrencyExchangeRate: any = 1;

  constructor(
    public app: AppMainComponent,
    public appMainService: AppMainService,
    public datepipe: DatePipe,
    private utilityService: UtilityService,
  ) {
    this.utilService = this.utilityService;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.rmaTemplate = this.templates?.find((t) => t.typeId == TemplateType.CustomerRMA);
  }

  async getCustomerReturnsInfo(customerReturnPrintObj, type) {
    this.customerReturnDetails = customerReturnPrintObj;
    this.savedCurrencyUnit = this.customerReturnDetails?.account?.currencyUnit;
    this.savedCurrencyExchangeRate = Number(this.customerReturnDetails.exchangeRate ?? 1);
    this.loadCustomFields();
    this.preparecustomerRMAProducts(this.customerReturnDetails);
    this.getProductSerialDetails();
    this.setCustomFieldsData();
    setTimeout(() => {
      if (type === "PRINT") {
        this.print();
      } else {
        const attachment = this.getPDF();
        this.getCustomerReturnEmail.emit(attachment);
      }
    }, 1000);
  }

  loadCustomFields() {
    this.allModules = this.app?.preLoadedObjects;
    this.customFieldData = [];
    this.allCustomFields = [];
    const fields = this.allCustomAttributes?.filter((el) => el.section?.typeName == "Customer Returns");
    this.appMainService.isShowSpinner("loadAllTemplates");
    if (fields && fields.length > 0) {
      for (let l of fields) {
        let isChecked = this.rmaTemplate?.[l.section.code]?.find((el) => el.id == l.id && el.sectionId == l.section.id)?.IsPrint;
        if (isChecked) {
          let eachRecord = {
            id: Number(l.id + ""),
            name: l?.name ?? "",
            module: this.allModules.find((el) => el.id == l.objectId)?.name,
            formControl: l.formControl,
            formControlId: l.formControlId,
            isRequired: l.isRequired,
            statusId: l.statusId,
            statusName: l?.status?.name ?? "",
            section: l.section,
            configurationId: l.configurationId,
            isEdit: l.isEdit,
            isDelete: l.isDelete,
            pickupList: l.pickListValues ? JSON.stringify(l.pickListValues) : l.pickListValues,
          };
          this.customFieldData.push(eachRecord);
        }
      }
    }
    this.appMainService.isHideSpinner("loadAllTemplates");
    this.allCustomFields = this.customFieldData;
    this.customAtributes.billing_address_item = this.allCustomFields.filter((el) => el.section?.code == "labels_billaddress");
    this.customAtributes.shipping_address_item = this.allCustomFields.filter((el) => el.section?.code == "labels_shipaddress");
    this.customAtributes.misc_item = this.allCustomFields.filter((el) => el.section?.code == "labels_misc");
    this.customAtributes.message_item = this.allCustomFields.filter((el) => el.section?.code == "labels_message");
    this.customAtributes.other1_item = this.allCustomFields.filter((el) => el.section?.code == "labels_customerreturn_other1");
    this.customAtributes.other2_item = this.allCustomFields.filter((el) => el.section?.code == "labels_customerreturn_other2");
    this.customAtributes.other3_item = this.allCustomFields.filter((el) => el.section?.code == "labels_customerreturn_other3");
  }

  preparecustomerRMAProducts(res) {
    for (let prd of res.customerRMAProducts) {
      prd.typeId = prd.product?.typeId;
      prd.bin = prd?.bins?.filter((bin) => bin?.id == prd?.binId)?.map((binData) => binData?.name)[0];
      for (let bundle of prd.rmaBundleDetails) {
        bundle.typeId = bundle.product?.typeId;
        if (prd.product.typeId == 6) {
          bundle.originalOrdQty = JSON.parse(JSON.stringify(bundle.qty));
        }
        if (bundle.childRMABundleDto?.length > 0) {
          for (let kp of bundle.childRMABundleDto) {
            kp.typeId = kp.product?.typeId;
            kp.originalOrdQty = JSON.parse(JSON.stringify(kp.qty));
          }
          bundle.rmaBundleDetails = bundle.childRMABundleDto;
        }
      }
    }
    this.selectedProductListTable = JSON.parse(JSON.stringify(res.customerRMAProducts));
  }

  getProductSerialDetails() {
    this.productsSerialDetails = [];
    this.productsSerialDetails = this.getProductsSerialDetails(this.customerReturnDetails?.customerRMAProducts);
  }

  getProductsSerialDetails(productListTB = []) {
    const trackingDetails = [];
    productListTB?.forEach((product) => {
      trackingDetails.push(this.getSerialDetailsObj(product?.itemNo, product?.rmaProductSerialDetails));
    });

    return trackingDetails;
  }

  getSerialDetailsObj(name = "", trckDetails = []): any {
    const groupedData: any[] = [];
    for (let i = 0; i < trckDetails.length; i += 3) {
      groupedData.push(trckDetails.slice(i, i + 3));
    }
    const obj = {
      itemName: name,
      serialDetails: groupedData,
    };
    return obj;
  }

  setCustomFieldsData() {
    this.appMainService.isShowSpinner("setCustomFieldsData");
    Object.keys(this.customAtributes).forEach((key) => {
      const dataArr = this.customAtributes[key];
      if (dataArr && dataArr.length > 0) {
        dataArr.forEach((element) => {
          const filteredCustom = this.customerReturnDetails?.customAttributeValues?.filter((c) => c.customAttributeId == element.id)[0];
          if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
            element.value = filteredCustom.value;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
            element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
          } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
            element.customUploadedFiles = [];
            filteredCustom.customeAttachement.forEach((el) => {
              element.customUploadedFiles.push(el);
            });
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
            element.value = filteredCustom.ratingId;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
            element.value = filteredCustom.toggle;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
            element.value = filteredCustom.values;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
            element.value = filteredCustom.values.name;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
            element.value = [];
            filteredCustom.multipleValues.forEach((el) => {
              element.value.push(el.name);
            });
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
            element.value = [];
            filteredCustom.multipleValues.forEach((el) => {
              element.value.push(el);
            });
          }
        });
      }
    });
    this.appMainService.isHideSpinner("setCustomFieldsData");
  }

  print() {
    let pdf = new jsPDF("p", "pt", "a4", true);
    pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
    pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
    pdf.setFont("Roboto-Regular");
    let html = document.getElementById("customerReturnPreview").innerHTML;
    html = html.replace(/width="100%"/, 'width="555"');
    let pdfFileName = `Customer Returns_${this.customerReturnDetails.number}`;
    pdf.setProperties({ title: pdfFileName + ".pdf" });
    pdf.html(html, {
      callback: function (pdf) {
        const dataUri = pdf?.output("datauristring");
        const newTab = window?.open();
        newTab?.document?.write('<iframe width="100%" height="100%" src="' + dataUri + '" type="application/pdf"></iframe>');
        newTab.document.title = pdfFileName + ".pdf";
      },
      margin: [40, 20],
    });
    return pdf;
  }

  getPDF() {
    let pdf = new jsPDF("p", "pt", "a4", true);
    pdf?.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
    pdf?.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
    pdf?.setFont("Roboto-Regular");

    let html = document?.getElementById("customerReturnPreview").innerHTML;
    html = html.replace(/width="100%"/, 'width="555"');
    pdf.html(html, {
      margin: [40, 20],
    });
    return pdf;
  }
}
